import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { DELETE_USER_LOG_REQUEST, GET_USER_LOG_LIST_REQUEST } from "./type";
import {
  deleteUserLogSuccess,
  getUserLogListRequest,
  getUserLogListSuccess,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";

/* Login/logout history of one user. The same endpoint serves a portal user
   (userType "S") and a member (userType "M") - only the payload differs. */
function* userLogList({ payload: data }) {
  try {
    const res = yield call(invokeApi, "post", "/userLogList", data);
    if (res.status) {
      yield put(getUserLogListSuccess(res.data));
    } else {
      yield put(getUserLogListSuccess([]));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(getUserLogListSuccess([]));
    handleApiCallException(error);
  }
}

function* deleteUserLog({ payload: data }) {
  try {
    const res = yield call(invokeApi, "post", "/userLogDelete", {
      userType: data.userType,
      fromDate: data.fromDate,
      toDate: data.toDate,
      searchText: data.searchText,
    });
    if (res.status) {
      ApiResponseMessage(res.message, SUCCESS);
      yield put(deleteUserLogSuccess(res));
      yield put(getUserLogListRequest(data.listData));
    } else {
      yield put(deleteUserLogSuccess([]));
      ApiResponseMessage(res.message, DANGER);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(deleteUserLogSuccess([]));
    handleApiCallException(error);
  }
}

function* watchUserLogRequest() {
  yield takeLatest(GET_USER_LOG_LIST_REQUEST, userLogList);
  yield takeLatest(DELETE_USER_LOG_REQUEST, deleteUserLog);
}

function* AdminUserLogSaga() {
  yield all([fork(watchUserLogRequest)]);
}

export default AdminUserLogSaga;
